import { useTheme } from '@emotion/react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
  Popover,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { request66W } from 'api/apiService';
import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import {
  DateTimePicker,
  LocalizationProvider,
  MobileDateTimePicker,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Clock, ContractReceipt, HomeIcon } from './PublishedIcon';
import RefreshIcon from '@mui/icons-material/Refresh';
import moment from 'moment/moment';
import Loading from 'assets/images/loading.png';
import GeneratePdfDialog from 'component/VendorGeneratePdf';
import ViewCommenceEsignPdf from 'component/BuyersMarketplace/ViewCommenceEsignPdf';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import DocumentHub from 'component/FileManager/DocumentHub';

const ViewIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.125 10.5C13.125 11.9498 11.9497 13.125 10.5 13.125C9.05025 13.125 7.875 11.9498 7.875 10.5C7.875 9.05021 9.05025 7.875 10.5 7.875C11.9497 7.875 13.125 9.05021 13.125 10.5Z"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.15234 10.5C3.26733 6.95002 6.58383 4.375 10.5018 4.375C14.4197 4.375 17.7362 6.95005 18.8512 10.5C17.7362 14.05 14.4197 16.625 10.5018 16.625C6.58383 16.625 3.26731 14.05 2.15234 10.5Z"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const Trash = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_31549_74221)">
        <path
          d="M3.5 6.125H17.5"
          stroke="#FF3B30"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.75 9.625V14.875"
          stroke="#FF3B30"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.25 9.625V14.875"
          stroke="#FF3B30"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.375 6.125L5.25 16.625C5.25 17.0891 5.43437 17.5342 5.76256 17.8624C6.09075 18.1906 6.53587 18.375 7 18.375H14C14.4641 18.375 14.9092 18.1906 15.2374 17.8624C15.5656 17.5342 15.75 17.0891 15.75 16.625L16.625 6.125"
          stroke="#FF3B30"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.875 6.125V3.5C7.875 3.26794 7.96719 3.04538 8.13128 2.88128C8.29538 2.71719 8.51794 2.625 8.75 2.625H12.25C12.4821 2.625 12.7046 2.71719 12.8687 2.88128C13.0328 3.04538 13.125 3.26794 13.125 3.5V6.125"
          stroke="#FF3B30"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_31549_74221">
          <rect width="21" height="21" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const BuyerSolicitorStatusPopup = ({
  idCheckPending,
  openCheckPending,
  setAnchorElPending,
  anchorElPending,
  address,
  selectedeta,
  selectedDate,
  setSelectedDate,
  isBuyer,
  statustext,
  minDate,
  handleDateChange,
  Openmessage,
  popupBinderId,
  propertyId,
  buyerId,
  createdDate,
  updatedDate,
  handleCloseCheckPending,
  contarctETADate,
  ETAdialogChanged,
  setMessage,
  url66W,
  Getuserlist,
  confirmLoading,
  setConfirmLoading,
  primaryUserTypeValue,
  selectedPropertyAddress,
  anchorRef,
}) => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches400 = useMediaQuery(theme.breakpoints.down(400));

  const [isDateChanged, setIsDateChanged] = useState(false);
  const [error, setError] = useState('');
  const [redoLoading, setRedoLoading] = useState(false);
  const [openEsign, setOpenEsign] = useState(false);
  const [openRedoDialog, setOpenRedoDialog] = useState(false);
  const [lastAnchorEl, setLastAnchorEl] = useState(null);
  const [isOpenFileManager, setIsOpenFileManager] = useState(false);

  const req66W = (propertyId, buyerId) => {
    setRedoLoading(true);
    const input = {
      propertyId: propertyId,
      isBuyer: 0,
      buyerId: buyerId,
    };
    request66W(input)
      .then((res) => {
        if (res?.status == 1) {
          setAnchorElPending(null);
          const message = res?.message || '';

          const lastForIndex = message.lastIndexOf(' for ');

          let formattedMessage = message;

          if (lastForIndex !== -1) {
            const before = message.substring(0, lastForIndex + 5); // include ' for '
            const after = message.substring(lastForIndex + 5);

            formattedMessage = `${before}<strong>${after.replace(
              /\.$/,
              ''
            )}</strong>.`;
          }
          Swal.fire({
            title: res?.heading ? res?.heading : 'Success',
            html: formattedMessage,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
            allowOutsideClick: false,
          });
        } else {
          Swal.fire({
            title: res?.heading ? res?.heading : 'Error',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          });
        }
      })
      .catch((res) => {
        Swal.fire({
          title: res?.heading ? res?.heading : 'Error',
          text: res?.message,
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        });
      })
      .finally(() => {
        // ✅ this ensures loader always stops, success or error
        setRedoLoading(false);
      });
  };

  const DateTimePickerComponent = matchessm
    ? MobileDateTimePicker
    : DateTimePicker;

  useEffect(() => {
    if (redoLoading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [redoLoading]);
  // const handleView = () => {
  //   setAnchorElPending(null);
  //   setOpenEsign(true);
  // };
  const [openViewDialog, setOpenViewDialog] = useState(false);

  const handleCloseView = () => {
    setOpenViewDialog(false);
  };

  const handleView = () => {
    if (selectedeta != 'Contract' && statustext == 'Completed') {
      setAnchorElPending(null);
      setOpenViewDialog(true);
      return;
    }
    // 🔹 CONTRACT → binder navigation + close popup
    if (selectedeta === 'Contract') {
      setAnchorElPending(null); // ✅ close popup

      // if (popupBinderId) {
      //   setMessage(true);
      //   Openmessage(popupBinderId);
      // }
      setIsOpenFileManager(true);
      setAnchorElPending(null);
      return;
    }

    // 🔹 NON-CONTRACT (66W) → popup only
    setAnchorElPending(null);
    setOpenEsign(true);
  };

  return (
    <>
      <Popover
        id={idCheckPending}
        open={Boolean(anchorElPending)}
        // anchorReference={matches800 ? "anchorPosition" : "anchorEl"}
        // anchorPosition={
        //   matches800 ? { top: window.innerHeight / 2, left: 0 } : undefined
        // }
        anchorEl={anchorElPending}
        onClose={() => {
          setSelectedDate(null);
          setAnchorElPending(null);
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          borderRadius: '10px',
          // transform: matchessm && "scale(1)",
          // transformOrigin: matchessm && "0 0",
          height: '100%',
          // minWidth: matches800 ? "100vw" : "583px",
          // position: matchessm ? "fixed" : "absolute",
          // left: 0,
          // top: 0,
          // "& .MuiPopover-paper": {
          //   minWidth: matches800 ? "90%" : "583px",
          // },
        }}
      >
        <Grid
          item
          sx={{
            padding: matchessm ? '0 0px' : '20px',
            m: '10px',
            display: 'flex',
            alignItems: 'center',
            gap: matchessm ? '10px' : '20px',
            minWidth: matchessm ? '90%' : '583px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '5px',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <HomeIcon style={{ width: '21px', height: '20px' }} /> &nbsp;{' '}
            </div>
            <Typography
              sx={{
                color: '#666',
                fontFamily: 'poppins',
                fontSize: matchessm ? '12px' : '14px',
                fontWeight: 500,
              }}
            >
              {address}
            </Typography>
          </Box>
        </Grid>
        <Divider sx={{ borderColor: '#D9D9D9' }} />
        <Grid
          item
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '50px',
            mt: '20px',
            pl: matchessm ? '0px' : '30px',
            position: 'relative',
            m: '10px',
          }}
        >
          <Grid
            sx={{ textAlign: 'left', padding: matchessm ? '0 0px' : '0px' }}
          >
            <>
              <Typography
                sx={{
                  position: !matchessm && 'absolute',
                  top: !matchessm && '0px',
                  right: !matchessm && '30px',
                  fontFamily: 'poppins',
                  fontSize: '12px',
                  color: '#D9D9D9',
                  fontWeight: 400,
                }}
              >
                Created:{' '}
                {new Date(createdDate).getDate().toString().padStart(2, '0')}-
                {(new Date(createdDate).getMonth() + 1)
                  .toString()
                  .padStart(2, '0')}
                -{new Date(createdDate).getFullYear()}
              </Typography>
              <br />
              {createdDate != updatedDate && (
                <Typography
                  sx={{
                    position: !matchessm && 'absolute',
                    top: !matchessm && '20px',
                    right: !matchessm && '30px',
                    fontFamily: 'poppins',
                    fontSize: '12px',
                    color: '#D9D9D9',
                    fontWeight: 400,
                  }}
                >
                  Updated:{' '}
                  {new Date(updatedDate).getDate().toString().padStart(2, '0')}-
                  {(new Date(updatedDate).getMonth() + 1)
                    .toString()
                    .padStart(2, '0')}
                  -{new Date(updatedDate).getFullYear()}
                </Typography>
              )}
            </>
          </Grid>
          <Grid
            xs={10}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: matches400 ? '10px' : '20px',
              justifyContent: 'center',
              paddingX: matchessm && '0px',
              //border:"1px solid red"
            }}
          >
            <Grid
              xs={10}
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                gap: matchessm ? '5px' : '20px',
                width: matchessm ? '100%' : '80%',
                justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '10px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <ContractReceipt style={{ width: '18px' }} /> &nbsp;{' '}
                </div>
                <Typography
                  sx={{
                    color: '#666',
                    fontFamily: 'poppins',
                    fontSize: matchessm ? '14px' : '16px',
                    fontWeight: 500,
                  }}
                >
                  {selectedeta == '66W' ? 's66W' : selectedeta} Status
                </Typography>
              </Box>
              <Typography
                sx={{
                  // background: getColor(statustext),
                  display: 'flex',
                  background:
                    statustext == 'Completed'
                      ? '#08A742'
                      : statustext == 'Action Required'
                      ? '#F93939'
                      : 'grey',
                  padding: '4px 5px',
                  color: 'white',
                  fontFamily: 'poppins',
                  borderRadius: '5px',
                  fontWeight: 300,
                  fontSize: matchessm ? '12px' : '',
                  width: '50%',
                  height: '35px',
                  boxSizing: 'border-box',
                  textAlign: 'center',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {statustext}
              </Typography>
            </Grid>
            <Grid
              //  border={"1px solid red"}
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                gap: matchessm ? '5px' : '10px',
              }}
            >
              <Grid
                xs={10}
                // border={1}
                sx={{
                  //padding: matchessm ? "0 10px" : "0 20px",
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  gap: matchessm ? '10px' : '20px',
                  width: matchessm ? '100%' : '80%',
                  pointerEvents: statustext === 'Completed' ? 'none' : 'auto',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '10px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Clock style={{ width: '18px' }} /> &nbsp;{' '}
                  </div>

                  <Typography
                    sx={{
                      color: '#666',
                      fontFamily: 'poppins',
                      fontSize: matchessm ? '14px' : '16px',
                      fontWeight: 500,
                    }}
                  >
                    ETA
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: matchessm ? '60%' : '50%',
                    borderRadius: '5px',
                  }}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePickerComponent
                      disablePast
                      disablePortal
                      format="DD-MM-YYYY hh:mm a"
                      required
                      minDate={minDate}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          required: true,
                          placeholder: contarctETADate
                            ? moment(contarctETADate).format('DD-MM-YYYY')
                            : 'DD-MM-YYYY ',
                        },
                      }}
                      value={selectedDate}
                      onChange={(e) => {
                        setIsDateChanged(true);
                        setError('');
                        handleDateChange(e);
                      }}
                      sx={{
                        height: '35px',
                        '& .MuiInputBase-root': {
                          height: '35px',
                        },
                        '& .MuiInputBase-input': {
                          padding: '4px 5px 4px 5px',
                          fontSize: matches400 ? '11px' : '14px',
                          border: 'none',
                          // width: "100%",
                          '&::placeholder': {
                            color: 'black',
                            fontWeight: '500',
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      disablePast
                      value={selectedDate}
                      minDate={minDate}
                      onChange={handleDateChange}
                      format="DD-MM-YYYY hh:mm:ss a"
                      slotProps={{
                        textField: {
                          placeholder: contarctETADate
                            ? moment(contarctETADate).format("DD-MM-YYYY HH:mm")
                            : "",
                        },
              
                      }}
                      sx={{
                        width: "90%",
                        "& .MuiOutlinedInput-root": {
                          padding: "0px",
                          "& fieldset": {
                            border: "none",
                          },
                          "&:hover fieldset": {
                            border: "none",
                          },
                          "&.Mui-focused fieldset": {
                            border: "none",
                          },
                        },
                        "& .MuiInputBase-input": {
                          padding: "4px 0px 4px 0px",
                          fontSize: matches400 ? "10px" : "14px",
                          border: "none",
                         // width: "100%",
                          "&::placeholder": {
                            color: "black",
                            fontWeight: "500",
                          },
                        },
                        "& .MuiSvgIcon-root": {
                          //ml: "10px",
                          cursor: "pointer",
                          //fontSize: matchessm ? "12px" : "16px",
                        },
                        "& .MuiInputBase-root": {
                         // height: "35px",
                        },
                      }}
                    />
                  </LocalizationProvider> */}
                </Box>
              </Grid>
              {/* <Button
              variant="contained"
              sx={{
                background: '#007AFF',
                padding: '0px',
                // padding: matchessm ? "7px 20px" : "10px 39px",
                // border: "1px solid #007AFF",
                fontFamily: 'poppins',
                color: '#FFFFFF',
                fontWeight: 400,
                fontSize: matchessm ? '12px' : '14px',
                borderRadius: '5px',
                display: 'flex',
                alignItems: 'center',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#007AFF',
                  borderColor: '#007AFF',
                },
              }}
              disabled={!isDateChanged || !selectedDate}
              onClick={() => {
                setSelectedDate(null);
                handleCloseCheckPending();
              }}
            >
              {contarctETADate ? 'Update' : 'Save'}
            </Button> */}

              <Button
                variant="contained"
                sx={{
                  background: '#007AFF',
                  padding: '0px',
                  fontFamily: 'poppins',
                  color: '#FFFFFF',
                  fontWeight: 400,
                  fontSize: matchessm ? '12px' : '14px',
                  borderRadius: '5px',
                  display: 'flex',
                  alignItems: 'center',
                  textTransform: 'none',
                  '&:hover': {
                    backgroundColor: '#007AFF',
                    borderColor: '#007AFF',
                  },
                }}
                disabled={!isDateChanged || !selectedDate}
                onClick={async () => {
                  setRedoLoading(true); // 🔹 start loader
                  try {
                    setSelectedDate(null);
                    await handleCloseCheckPending(); // keep your same function
                  } finally {
                    setRedoLoading(false); // 🔹 stop loader
                  }
                }}
              >
                {contarctETADate ? 'Update' : 'Save'}
              </Button>

              {redoLoading && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          sx={{
            padding: matchessm ? '0 10px 30px 30px' : '0 30px 30px 30px',
            mt: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: matchessm ? '5px' : '10px',
          }}
        >
          <>
            <Button
              sx={{
                background: '#007AFF',
                padding: matchessm ? '7px 20px' : '10px 39px',
                border: '1px solid #007AFF',
                fontFamily: 'poppins',
                color: '#FFFFFF',
                fontWeight: 400,
                fontSize: matchessm ? '12px' : '14px',
                borderRadius: '5px',
                display: 'flex',
                alignItems: 'center',
                textTransform: 'none',
                width: '127px',
                height: '41px',
                '&:hover': {
                  backgroundColor: '#007AFF',
                  borderColor: '#007AFF',
                },
              }}
              variant="outlined"
              // onClick={() => {
              //   if (popupBinderId) {
              //     setMessage(true);
              //     Openmessage(popupBinderId);
              //   }
              // }}
              onClick={handleView}
              startIcon={<ViewIcon />}
            >
              View
            </Button>

            {selectedeta != 'Contract' && (
              <>
                <Button
                  sx={{
                    padding: matchessm ? '7px 20px' : '10px 39px',
                    border: '1px solid #007AFF',
                    fontFamily: 'poppins',
                    color: '#007AFF',
                    fontWeight: 400,
                    fontSize: matchessm ? '12px' : '14px',
                    borderRadius: '5px',
                    display: 'flex',
                    alignItems: 'center',
                    textTransform: 'none',
                    width: '127px',
                    height: '41px',
                  }}
                  variant="outlined"
                  onClick={(event) => {
                    setLastAnchorEl(anchorElPending);
                    setAnchorElPending(null);
                    setOpenRedoDialog(true);
                  }}
                  // onClick={() => {
                  //   req66W(propertyId, buyerId);
                  // }}
                  startIcon={<RefreshIcon />}
                  disabled={
                    statustext == 'Action Required'
                      ? true
                      : redoLoading
                      ? true
                      : false
                  }
                >
                  Redo
                </Button>
                {redoLoading && (
                  <img
                    alt="Logo"
                    src={Loading}
                    className="loaderImage"
                    style={{ height: '40px', width: '40px' }}
                  />
                )}

                <Button
                  sx={{
                    padding: matchessm ? '7px 20px' : '10px 39px',
                    border: '1px solid #FF3830',
                    fontFamily: 'poppins',
                    color: '#FF3830',
                    fontWeight: 400,
                    fontSize: matchessm ? '12px' : '14px',
                    borderRadius: '5px',
                    display: 'flex',
                    alignItems: 'center',
                    textTransform: 'none',
                    width: '127px',
                    height: '41px',
                    backgroundColor: '#FFFFFF', // keep consistent background
                    boxShadow: 'none', // remove ripple shadow
                    '&:hover': {
                      border: '1px solid #FF3830',
                      color: '#FF3830',
                      backgroundColor: '#FFFFFF', // override default gray hover
                      boxShadow: 'none', // remove shadow on hover
                    },
                  }}
                  disableElevation
                  disableRipple
                  variant="outlined"
                  startIcon={<Trash />}
                >
                  Delete
                </Button>
              </>
            )}
            {/* {selectedeta == 'Contract' && (
              <Button
                sx={{
                  padding: matchessm ? '7px 20px' : '10px 39px',
                  border: '1px solid #34C759',
                  fontFamily: 'poppins',
                  color: '#34C759',
                  fontWeight: 400,
                  fontSize: matchessm ? '12px' : '14px',
                  borderRadius: '5px',
                  display: 'flex',
                  alignItems: 'center',
                  textTransform: 'none',
                  width: '127px',
                  height: '41px',
                  '&:hover': {
                    border: '1px solid #34C759',
                    color: '#34C759',
                    backgroundColor: '#FFFFFF', // override default gray hover
                    boxShadow: 'none', // remove shadow on hover
                  },
                }}
                disableElevation
                disableRipple
                variant="outlined"
                startIcon={<Tick />}
              >
                Approve
              </Button>
            )} */}
          </>
        </Grid>
        <Divider sx={{ borderColor: '#D9D9D9' }} />
        <Grid
          item
          sx={{
            padding: matchessm ? '0 0px' : '0 35px',
            display: 'flex',
            alignItems: 'center',
            gap: matchessm ? '10px' : '20px',
            m: matchessm ? '10px' : '0px',
            marginTop: '20px',
          }}
        >
          <Typography
            sx={{
              color: '#666',
              fontFamily: 'poppins',
              fontSize: matchessm ? '14px' : '16px',
              fontWeight: 500,
            }}
          >
            Messaging
          </Typography>
        </Grid>
        <Grid
          sx={{
            padding:
              selectedeta == 'Contract'
                ? '0px 20px 30px 20px'
                : matches400
                ? '0px 0px 30px 0px'
                : '0 30px 30px 0px ',

            m: matches400 ? '10px' : '0px',
            mt: '20px',
            display: 'flex',
            alignItems: 'center',
            flexDirection: matches400 ? 'column' : 'row',
            justifyContent:
              selectedeta == 'Contract'
                ? 'right'
                : matches400
                ? 'center'
                : 'right',
            gap: '20px',
            // border:"1px solid red"
          }}
        >
          <Button
            sx={{
              padding: matchessm ? '7px 20px' : '10px 53px',
              border: '1px solid #007AFF',
              fontFamily: 'poppins',
              color: '#007AFF',
              fontWeight: 400,
              fontSize: matchessm ? '12px' : '14px',
              borderRadius: '5px',
              display: 'flex',
              alignItems: 'center',
              textTransform: 'none',
              width: matches400 ? '100%' : '165px',
              height: '41px',
            }}
            variant="outlined"
          >
            Client
          </Button>
          {selectedeta == 'Contract' && (
            <Button
              sx={{
                padding: matchessm ? '7px 20px' : '10px 53px',
                border: '1px solid #007AFF',
                fontFamily: 'poppins',
                color: '#007AFF',
                fontWeight: 400,
                fontSize: matchessm ? '12px' : '14px',
                borderRadius: '5px',
                display: 'flex',
                alignItems: 'center',
                textTransform: 'none',
                width: matches400 ? '100%' : '165px',
                height: '41px',
              }}
              variant="outlined"
            >
              Solicitor
            </Button>
          )}
          <Button
            sx={{
              padding: matchessm ? '7px 20px' : '10px 53px',
              border: '1px solid #007AFF',
              fontFamily: 'poppins',
              color: '#007AFF',
              fontWeight: 400,
              fontSize: matchessm ? '12px' : '14px',
              borderRadius: '5px',
              display: 'flex',
              alignItems: 'center',
              textTransform: 'none',
              width: matches400 ? '100%' : '165px',
              height: '41px',
            }}
            variant="outlined"
          >
            Agent
          </Button>
        </Grid>
      </Popover>

      <GeneratePdfDialog
        open={openEsign}
        onClose={() => setOpenEsign(false)}
        propertyId={propertyId}
        buyerId={buyerId}
        address={address}
        status={''}
        offerUniqueId={''}
        getListInfo={Getuserlist}
        confirmLoading={confirmLoading}
        setConfirmLoading={setConfirmLoading}
      />
      {openViewDialog && (
        <ViewCommenceEsignPdf
          open={openViewDialog}
          onClose={handleCloseView}
          taskPath={url66W}
          streetName={address}
          matchessm={matchessm}
          wStatus={true}
          primaryUserTypeValue={primaryUserTypeValue}
        />
      )}
      {openRedoDialog && (
        <Dialog
          open={openRedoDialog}
          onClose={() => setOpenRedoDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogContent sx={{ padding: '24px 24px 16px 24px' }}>
            <Typography
              sx={{
                fontSize: '13px',
                color: '#6B7280',
                fontFamily: 'Poppins',
                marginBottom: '24px',
              }}
            >
              {address}
            </Typography>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                marginBottom: '16px',
              }}
            >
              <Pendingwarning style={{ width: 22, height: 22 }} />
              <Typography
                sx={{
                  fontSize: '22px',
                  fontWeight: 600,
                  fontFamily: 'Poppins',
                  color: '#111827',
                }}
              >
                Redo s66W
              </Typography>
            </Box>

            <Typography
              sx={{
                fontSize: '14px',
                color: '#6B7280',
                fontFamily: 'Poppins',
                marginTop: '12px',
              }}
            >
              Are you sure you want to re-initiate the signing process for the
              s66W document?
            </Typography>
          </DialogContent>

          <DialogActions
            sx={{
              padding: '16px 24px 24px 24px',
              justifyContent: 'flex-end',
              gap: '12px',
            }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                setOpenRedoDialog(false);
                setAnchorElPending(lastAnchorEl);
              }}
              sx={{
                textTransform: 'none',
                fontFamily: 'Poppins',
                borderColor: '#D1D5DB',
                color: '#374151',
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={() => {
                setOpenRedoDialog(false);
                req66W(propertyId, buyerId);
              }}
              sx={{
                textTransform: 'none',
                fontFamily: 'Poppins',
              }}
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {isOpenFileManager && (
        <Dialog
          open={isOpenFileManager}
          onClose={() => setIsOpenFileManager(false)}
          maxWidth={false}
          fullWidth
          sx={{
            '& .MuiDialog-paper': {
              width: '100%',
              minWidth: '1600px',
            },
          }}
        >
          <DocumentHub
            isFromBuyerSolicitor={true}
            isFromVendorSolicitor={false}
            onBack={() => {
              setIsOpenFileManager(false);

              setAnchorElPending(anchorRef?.current);
            }}
            propertyAddress={address}
            isDialog={true}
            propertyId={propertyId}
            buyerId={buyerId}
            userType={'Buyer Solicitor'}
            isDirectBuyerDocumentHistory={true}
            backToContract={() => {
              setIsOpenFileManager(false);
              setTimeout(() => {
                setAnchorElPending(anchorRef?.current);
              }, 0);
            }}
            selectedeta={selectedeta}
            statustext={statustext}
          />
        </Dialog>
      )}
    </>
  );
};

export default BuyerSolicitorStatusPopup;
